var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "79px",
    height: "79px",
    viewBox: "-0.5 -0.5 79 79",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T12:17:24.468Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"wh_1rndc0i_Po9xMe9Rc\" version=\"16.5.1\" type=\"device\"><diagram id=\"u4Q9mtqc-7ff_6t4GGxs\" name=\"Page-1\">jZRRb6MwDIB/DY+rGrKW3uNg3W3SJp3UTad7zMBA1IBRSFd6v/6cJrRQmHQtbePPduy4sQOeVN1PLZryDTNQQbjMuoA/BmHIN2v6tuDkQLi6d6DQMnOIXcFO/gUPl54eZAbtyNAgKiObMUyxriE1Iya0xuPYLEc1jtqIAiZglwo1pb9lZkpHN2F05c8gi7KPzNY/nKYSvbE/SVuKDI8DxLcBTzSicauqS0DZ2vV1cX5P32gviWmozf84fOw+ivX7tn7f53dR8rz988rEnd/lS6iDP7BP1pz6CrR7MKk9yjLgcYOyNueSrmJ6KGLiPisyTSxZhKsZOMeiKWRTM/phcxFu4RyLppBNzazUZz2GcyxaTTO+9WYz3uzGmx4e48EoWUNyuby2xjnWJkGF+lx/Tu8n+4/GhRaZhJFuvXzgPBroHqWmjSTWpK9R2ysY51Kp4X5RRLeUeGs07mGgyc8v0mSiLSHz6XyBNpIa4lV8gvqFrfTbf6IxWA0MHpQsrMJgQ1R4KaWsgALEpakUycyf0Lc6C3vZ3zgbUrSNK0cuO5tHTL3TWGXVFXbKLMSxvV9oaPGgU3hJbT4xiW41tmo56fwtp0Sh+7Z92KUpaZgBVmD0iUy8w9q38alvdC8fr1Mh2jhUDgZCz4SfQ8Vl42ur0sJ3ay9ep8JZNxitfPsP</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-60a337-1-277116-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(39, 113, 22)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96, 163, 55)",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 78 0 L 78 78 L 0 78 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.28 42.22 L 62.71 39.21 C 66.66 41.57 66.71 42.55 66.71 42.58 C 66.7 42.58 66.03 43.14 62.28 42.22 Z M 60.12 41.62 C 53.3 39.56 43.8 35.2 39.96 33.39 C 39.96 33.37 39.96 33.36 39.96 33.34 C 39.96 31.86 38.76 30.66 37.28 30.66 C 35.81 30.66 34.61 31.86 34.61 33.34 C 34.61 34.82 35.81 36.02 37.28 36.02 C 37.93 36.02 38.52 35.78 38.98 35.39 C 43.51 37.53 52.93 41.82 59.8 43.85 L 57.08 63.03 C 57.07 63.08 57.07 63.13 57.07 63.18 C 57.07 64.87 49.6 67.97 37.39 67.97 C 25.05 67.97 17.49 64.87 17.49 63.18 C 17.49 63.13 17.49 63.08 17.48 63.03 L 11.81 21.57 C 16.72 24.95 27.29 26.74 37.39 26.74 C 47.48 26.74 58.03 24.96 62.96 21.59 Z M 11.21 17.25 C 11.29 15.78 19.71 10.03 37.39 10.03 C 55.07 10.03 63.5 15.78 63.58 17.25 L 63.58 17.75 C 62.61 21.04 51.69 24.51 37.39 24.51 C 23.07 24.51 12.15 21.02 11.21 17.73 Z M 65.81 17.27 C 65.81 13.41 54.74 7.8 37.39 7.8 C 20.05 7.8 8.98 13.41 8.98 17.27 L 9.08 18.11 L 15.27 63.27 C 15.41 68.32 28.88 70.2 37.39 70.2 C 47.94 70.2 59.15 67.77 59.3 63.27 L 61.97 44.44 C 63.45 44.8 64.68 44.98 65.66 44.98 C 66.98 44.98 67.87 44.66 68.41 44.01 C 68.85 43.48 69.02 42.85 68.89 42.16 C 68.61 40.62 66.77 38.96 63.05 36.83 L 65.69 18.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/S3.ff787f62a2aaf0738be8d781575a92fb.svg";
export { ForwardRef as ReactComponent };